<template>
  <loader v-if="isSaving" />
  <div v-else class="set-stock-order">
    <form-checkbox
      id="is-stock-order"
      :title="i18n.t('/OrderInfoBlock/IsStockOrder')"
      :disabled="quoteStatusIsSalesOrder"
    >
      <input
        id="is-stock-order"
        :checked="quoteIsStockOrder"
        type="checkbox"
        name="is-stock-order"
        data-qa="is-stock-order"
        :disabled="quoteStatusIsSalesOrder || null"
        @change="updateIsStockOrder"
      />
    </form-checkbox>
  </div>
</template>

<script>
import StoreConnector from '@/helpers/StoreConnector'
import FormCheckbox from '@/components/generic/presentational/atoms/formCheckbox/FormCheckbox.vue'
import Loader from '@/components/generic/presentational/atoms/loader/Loader.vue'
import { EventBus } from '@/plugins/event-bus'

export default {
  components: {
    FormCheckbox,
    Loader,
  },
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      quoteStatusIsSalesOrder: false,
      quoteIsStockOrder: false,
      isSaving: false,
    }
  },
  mounted() {
    StoreConnector.get('quote/quoteStatusIsSalesOrder', (data) => {
      this.quoteStatusIsSalesOrder = data
    })

    StoreConnector.get('quote/isStockOrder', (data) => {
      this.quoteIsStockOrder = data
    })

    StoreConnector.get('quote/isNew', (data) => {
      this.quoteIsNew = data
    })
  },
  methods: {
    async updateIsStockOrder(event) {
      await this.setIsStockOrder(event.target.checked)
    },
    async setIsStockOrder(checked) {
      try {
        this.isSaving = true
        await StoreConnector.dispatch('quote/setStockOrder', checked)
        EventBus.$emit('quote-is-stock-changed')
      } finally {
        this.isSaving = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.set-stock-order {
  margin-bottom: 1em;
}
</style>
